import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-for-java',
  templateUrl: './wait-for-java.component.html',
  styleUrls: ['./wait-for-java.component.css']
})
export class WaitForJavaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
